import {Component} from 'react';
import h from 'react-hyperscript';
import BarChartVertical from 'Components/DataViz/BarCharts/BarChartVertical';
import {LARGE_SCREEN_WIDTH} from 'Src/utils/utils';

class TabContent extends Component {
  constructor(props) {
    super(props);
    this.inactiveClasses = 'tab__content';
    this.activeClasses = 'tab__content active';
    this.smallViewportGraphSize = 950;
    this.largeViewportGraphSize = 554;
    this.state = {
      classes: this.inactiveClasses,
      graphContainerWidth: this.smallViewportGraphSize,
    };

    this.setRef = this.setRef.bind(this);
  }

  componentDidMount() {
    this.checkClasses();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.screenWidth !== this.props.screenWidth &&
      this.graphRef &&
      this.activeTab
    ) {
      this.setGraphContainerWidth();
    }

    if (this.props.activeTab !== prevProps.activeTab) {
      this.checkClasses();
    }
  }

  setRef(ref) {
    this.graphRef = ref;

    this.setGraphContainerWidth();
  }

  setGraphContainerWidth() {
    const graphContainerWidth = this.graphRef.current.offsetWidth;

    if (
      this.state.graphContainerWidth !== graphContainerWidth &&
      this.props.dynamicGraphSize
    ) {
      this.setState({
        graphContainerWidth,
      });
    } else if (this.state.graphContainerWidth) {
      this.setState({
        graphContainerWidth:
          this.props.screenWidth > LARGE_SCREEN_WIDTH ?
            this.largeViewportGraphSize :
            this.smallViewportGraphSize,
      });
    }
  }

  get activeTab() {
    return Number(this.props.activeTab) === this.props.i;
  }

  checkClasses() {
    if (this.activeTab) {
      this.setClasses(this.activeClasses);
    } else {
      this.setClasses(this.inactiveClasses);
    }
  }

  setClasses(value) {
    this.setState({
      classes: value,
    });
  }

  render() {
    return h(
        'div',
        {
          key: `${this.props.i}-tabs-content__key`,
          className: this.state.classes,
          datatab: this.props.i,
        },
        h(
            BarChartVertical,
            {
              key: `${this.props.id}__bar-graph`,
              id: `${this.props.id}__bar-graph`,
              data: this.props.createReviewBars(this.props.i),
              dataPrev: this.props.createReviewBars(this.props.i, true),
              barWidth: 10,
              parentId: this.props.parentId,
              color: '#1a73e8',
              chartName: this.props.chartName,
              chartNamePrev: this.props.chartNamePrev,
              size: [
                this.state.graphContainerWidth,
            this.props.chartName ? 182 : 200,
              ],
              setRef: this.setRef,
            },
            null
        )
    );
  }
}

export default TabContent;
